interface HeroProps {
  title?: string;
  subtitle?: string;
  backgroundUrl?: string;
  ctaText?: string;
  ctaLink?: string;
  overlayOpacity?: number;
}

export function HeroBlock({ props }: { props: HeroProps }) {
  const opacity = props.overlayOpacity ?? 0.4;
  return (
    <div
      className="relative w-full min-h-[360px] flex items-center justify-center text-white overflow-hidden rounded-xl"
      style={{
        backgroundImage: props.backgroundUrl ? `url(${props.backgroundUrl})` : undefined,
        backgroundColor: props.backgroundUrl ? undefined : 'var(--color-primary)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0 rounded-xl"
        style={{ backgroundColor: `rgba(0,0,0,${opacity})` }}
      />
      <div className="relative z-10 text-center px-6 py-12 max-w-2xl">
        {props.title && (
          <h1 className="text-3xl sm:text-4xl font-bold leading-tight mb-3">{props.title}</h1>
        )}
        {props.subtitle && (
          <p className="text-base sm:text-lg text-white/80 mb-6">{props.subtitle}</p>
        )}
        {props.ctaText && props.ctaLink && (
          <a
            href={props.ctaLink}
            className="inline-block px-6 py-2.5 rounded-lg bg-white text-zinc-900 font-semibold text-sm hover:bg-zinc-100 transition-colors"
          >
            {props.ctaText}
          </a>
        )}
      </div>
    </div>
  );
}
